import { ZigzagEvent } from '@common/log-manager';

export const useLegacyModelSizeUBL = () => {
  const impressionModelSize = (catalog_product_id: string) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'model_info',
      object_type: 'image',
      data: JSON.stringify({
        catalog_product_id,
      }),
    });
  };
  return { impressionModelSize };
};
